export const getPatientNameFromArray = (namePart?: string[] | null) => {
    return namePart?.length ? namePart.join(" ") : null;
};
